<template>
    <div data-cy="profile-menu">
        <Action class="focus:outline-hidden" :items="items">
            <template #activator="{ onClick }">
                <div
                    class="mt-[6px] h-[30px] w-[30px] cursor-pointer rounded-full ring-[1px] ring-gray-300"
                    @mouseenter="preloadImages(logoutImages)"
                >
                    <img
                        :src="profilePhoto"
                        class="h-[30px] w-[30px] rounded-full object-cover"
                        @click="onClick"
                    />
                </div>
            </template>
        </Action>
        <CreateTeamModal
            v-if="createTeamModal"
            @close="createTeamModal = false"
            @close-and-switch-to-team="handleCloseAndSwitchToTeam"
        />
    </div>
</template>

<script lang="ts" setup>
import Action from '@atomic/Actions/Action.vue';
import { ref, computed } from 'vue';
import { router } from '@inertiajs/vue3';
import { usePage } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { PlusCircleIcon } from '@heroicons/vue/24/outline';
import IActionNode from '@/types/Atomic/IActions';
import CreateTeamModal from './components/CreateTeamModal.vue';
import IUser from '@/types/Members/IUser';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { logoutImages, preloadImages } from '@/utils/preloadAuthImages';

const { fetchBanners } = useBanners();
const { fetchSubscriptions } = useSubscriptions();
const { getCurrentTeamMembersCount } = useTeamsAndMembers();

let createTeamModal = ref(false);

const isAdmin = computed(() => usePage().props.isAdmin);
const globalProps = computed(() => usePage<ITopolPageProps>().props);

const handleCloseAndSwitchToTeam = () => {
    createTeamModal.value = false;
    handleFetchBannersAndMembers();
};

const handleFetchBannersAndMembers = () => {
    fetchSubscriptions();
    fetchBanners();
    getCurrentTeamMembersCount();
};

const items: IActionNode[] = [
    {
        name: 'Preferences',
        onClick() {
            router.visit(route('settings.profile-settings.index'), {
                onSuccess: () => {
                    router.reload();
                },
            });
        },
    },
    {
        name: 'Logout',
        onClick() {
            router.post(route('logout'));
        },
    },
];

if (globalProps.value.user?.app_type === null || globalProps.value.user?.app_type == 'pro' || globalProps.value.user?.app_type == 'both') {
    items.splice(0, 0, {
        name: 'Templates',
        onClick() {
            router.visit(route('home'), {
                onSuccess: () => {
                    router.reload();
                },
            });
        },
    });

    items.splice(1, 0, {
        name: 'Create new team',
        icon: PlusCircleIcon,
        onClick() {
            createTeamModal.value = true;
        },
    });
}

if (isAdmin.value) {
    // Insert Kiosk before the last item (Logout)
    items.splice(items.length - 1, 0, {
        name: 'Kiosk',
        onClick() {
            router.visit(route('kiosk.users.index'));
        },
    });
}

const profilePhoto = computed(() => {
    const user = usePage().props.user as IUser;
    return user.profile_photo_path
        ? user.profile_photo_path
        : user.profile_photo_url;
});
</script>
